__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "vrm-main";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@microsoft/clarity", "1.0.0", () => (__webpack_require__.e(102).then(() => (() => (__webpack_require__(5102))))));
			register("@mui/material", "7.3.4", () => (Promise.all([__webpack_require__.e(893), __webpack_require__.e(707), __webpack_require__.e(582), __webpack_require__.e(360)]).then(() => (() => (__webpack_require__(5893))))));
			register("@reduxjs/toolkit", "2.9.0", () => (Promise.all([__webpack_require__.e(297), __webpack_require__.e(780)]).then(() => (() => (__webpack_require__(8297))))));
			register("@sentry/react", "9.46.0", () => (__webpack_require__.e(699).then(() => (() => (__webpack_require__(3699))))));
			register("axios", "1.12.2", () => (__webpack_require__.e(409).then(() => (() => (__webpack_require__(5409))))));
			register("darkreader", "4.9.112", () => (__webpack_require__.e(629).then(() => (() => (__webpack_require__(6629))))));
			register("react-dom", "19.1.1", () => (() => (__webpack_require__(9374))), 1);
			register("react-error-boundary", "6.0.0", () => (__webpack_require__.e(631).then(() => (() => (__webpack_require__(1631))))));
			register("react-redux", "9.2.0", () => (__webpack_require__.e(127).then(() => (() => (__webpack_require__(6127))))));
			register("react-router", "7.9.4", () => (__webpack_require__.e(890).then(() => (() => (__webpack_require__(1890))))));
			register("react-toastify", "11.0.5", () => (__webpack_require__.e(18).then(() => (() => (__webpack_require__(3018))))));
			register("react", "19.1.1", () => (() => (__webpack_require__(6364))), 1);
			register("zeron-ui", "6.2.0", () => (Promise.all([__webpack_require__.e(664), __webpack_require__.e(582)]).then(() => (() => (__webpack_require__(3664))))));
			initExternal(3430);
			initExternal(7306);
			initExternal(8119);
			initExternal(4067);
			initExternal(671);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};